import FullnessConfiguration from './fullness-configurations-page';

export default FullnessConfiguration;